import { useGlobalState } from "../context/context"

const useLoading = () => {
    const { dispatch } = useGlobalState();

    const show = () => {
        dispatch({ type: 'setLoading', loading: true });
    };

    const hide = () => {
        dispatch({ type: 'setLoading', loading: false });
    };

    return { show, hide };
}

export default useLoading;